import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class BaseComponentService {
    private triggerElementInViewSubject = new Subject<void>();

    public get triggerElementInView$() {
        return this.triggerElementInViewSubject.asObservable();
    }

    public triggerElementInView() {
        this.triggerElementInViewSubject.next();
    }
}
